// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__pIj0O","icon":"EditButton_icon__0llNF"};